import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import {
    cpOrderInvoiceLineItemsAllColumnsView,
    CpOrderInvoiceLineItemsColumnSpec,
} from './CpOrderInvoiceLineItemsTableSpec';
import { tblSpecLoadView } from '../../../core/table/tableViewsRepo';
import { cpOrderInvoiceDetailsTableViewAtom } from './cp_order_invoices_details_atoms';

// TableInit hook for CP Order Invoice Line Items
export function useCpOrderInvoiceLineItemsTableInit(): { init: boolean } {
    const [init, setInit] = useState(true);
    const setView = useSetAtom(cpOrderInvoiceDetailsTableViewAtom);

    useEffect(() => {
        // Use tblSpecLoadView to convert spec to TblView
        const colSpec = CpOrderInvoiceLineItemsColumnSpec();
        const viewSpec = cpOrderInvoiceLineItemsAllColumnsView();
        const tblView = tblSpecLoadView(viewSpec.key, [viewSpec], colSpec, () => viewSpec);
        if (tblView) {
            setView(tblView);
        }
        setTimeout(() => setInit(false), 0);
    }, [setView]);

    return { init };
}
